module.exports = __webpack_public_path__ + "img/gem-light-active.8a976f02.png";